import { useEffect } from 'react';

const Preview = (props) => {

  const { setPreviewItem, pages } = props;

  useEffect(() => {
    const handleReceiveMessage = (event) => {
      const { data } = event;
      if (data) {
        const { collection, entry } = data;
        if (collection === 'pages') {
          setPreviewItem({ ...entry, collection: 'pages' });
        }
      }
    }

    window.addEventListener('message', handleReceiveMessage, false);

    return () => {
      window.removeEventListener('message', handleReceiveMessage, false);
    }
  }, [setPreviewItem, pages]);

  return null;
}

export default Preview;